module.exports = __webpack_public_path__ + "img/convenience-1-image.43a7def7.jpg";